import { css } from '@linaria/core';

import info from './fonts/info.json';

const build = Math.random().toString(36).substring(7);

export const variants = {
  interactive: css``,
};

export const icon = css`
  :global {
    @font-face {
      font-family: 'icon-${build}';
      src: url('./fonts/icons.woff2') format('woff2');
      font-display: swap;
    }
  }
  font-family: 'icon-${build}' !important;
  overflow: hidden;
  display: inline-flex;
  font-style: normal;
  font-weight: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
  text-transform: none;
  width: 1em;
  white-space: nowrap;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  letter-spacing: initial !important;

  & svg {
    width: 100%;
  }

  ${Object.entries(info).reduce((acc, [iconName, { encodedCode }]) => {
    return {
      ...acc,
      [`&[data-icon="${iconName}"]:before`]: {
        content: `"${encodedCode}"`,
      },
    };
  }, {})}
`;
